import React, { useState } from 'react';

import Accordion from 'components/ui/Accordion';
import Typography from 'components/ui/Typography';
import Chevron from 'icons/chevron.svg';
import { cx } from 'utils';
import classes from './AccordionList.module.css';

export type AccordionListProps = {
  items: { content: React.ReactNode; key: React.Key; title: string }[];
} & React.PropsWithoutRef<React.ComponentProps<'div'>>;

const AccordionList = React.forwardRef(function AccordionList(
  props: AccordionListProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { items, ...rest } = props;

  const [openKey, setOpenKey] = useState<null | React.Key>(null);

  return (
    <div {...rest} className={classes.accordionList} ref={ref}>
      {items.map(v => {
        const isOpen = openKey === v.key;

        return (
          <div key={v.key} className={classes.accordionItem}>
            <div
              onClick={() => {
                setOpenKey(isOpen ? null : v.key);
              }}
              className={classes.headerRow}
            >
              <Typography component="p" variant="b">
                {v.title}
              </Typography>
              <Chevron className={cx(isOpen && classes.rotate)} />
            </div>
            <Accordion shown={isOpen}>{v.content}</Accordion>
            <div className={classes.divider}></div>
          </div>
        );
      })}
    </div>
  );
});

export default AccordionList;
